import OrdersWorkspace from "@/components/OrdersWorkspace";

export default function Purchasing() {
  return <OrdersWorkspace scope="orders" />;
}
